import { Link } from '@/i18n/routing';

import React, { JSX } from "react";

interface Props {
  href: string;
  children?: React.ReactNode;
}

/**
 * Needed to insert the LinkCustom element as an inline component inside a Trans component.
 */

const TranslatedInlineLink = (props: Props): JSX.Element => {
  // @ts-expect-error
  return <Link href={props.href}>{props.children}</Link>;
};

export default TranslatedInlineLink;
